"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import IImportation from "@/interfaces/importation.interface";
import importationService from "@/services/importation.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<IImportation> | null>;

export interface Props extends RequestPagination {
  filters: IFilter<IImportation>[];
}

type GetAllSwrParams = [string, number, number, IFilter<IImportation>[]];

const useGetImportations = ({ pageNumber, pageSize, filters }: Props): Return => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "mediaName");

  const fetcher = useSWR<PaginatedResponse<IImportation>, Error, GetAllSwrParams>(
    [SWR_KEYS.getImportations, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      importationService.filter(_filters, { pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );
  const { data = null, isValidating: isLoading, error } = fetcher;
  return { data, isLoading, error };
};

export default useGetImportations;
